import React from 'react'
import './intro.scss'
import Particles from 'react-particles-js'
import { Params } from '../../utils/particles'

function Intro() {
   return (
      <>
         <div className="intro">
            <Particles className="particles" params={Params} />
            <div className="intro__wrapper">
               <h1 className="intro__wrapper--backdrop"> Developer</h1>
               <div className="intro__wrapper--content">
                  <h1>
                     Newton <br /> F. Mbugua
                  </h1>

                  <div className="intro__wrapper--content-cta">
                     <a href="#about" className="btn btn__more">
                        view more
                     </a>
                     <a
                        href="/docs/resume.pdf"
                        className="btn btn__cv"
                        target="_blank"
                        rel="noopener noreferrer">
                        view resume
                     </a>
                  </div>
               </div>

               <div className="intro__wrapper--coder">
                  <div className="intro__wrapper--coder-coding">
                     <img src="/images/coder.png" alt="coder" />
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

export default Intro
